import React from "react";
import ViewInArIcon from "@mui/icons-material/ViewInAr";
import { Badge, IconButton, Tooltip } from "@mui/material";

interface ViewModelsButtonProps {
  total: number;
  unseen: number;
  onClick: () => void;
  disabled?: boolean;
}

const ViewModelsButton: React.FC<ViewModelsButtonProps> = ({
  total,
  unseen,
  onClick,
  disabled = false,
}) => {
  return (
    <Tooltip title="View 3D Models">
      <Badge badgeContent={unseen} color="error" overlap="circular">
        <IconButton
          onClick={onClick}
          disabled={disabled || total === 0}
        >
          <ViewInArIcon />
        </IconButton>
      </Badge>
    </Tooltip>
  );
};

export default ViewModelsButton;
